import { render, staticRenderFns } from "./changeTheme.vue?vue&type=template&id=3b7c927a&"
import script from "./changeTheme.vue?vue&type=script&lang=js&"
export * from "./changeTheme.vue?vue&type=script&lang=js&"
import style0 from "./changeTheme.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports